import React, 
{ 
    useEffect,
    useState 
} from 'react'

import toast from 'react-hot-toast';
import dayjs from 'dayjs';

import { 
    Delete,
    Edit,
} from '@mui/icons-material';

import { 
    Form,
    Input,
    Col, 
    Row,
    Table,
    Space,
    Button,
    DatePicker,
    Select,
} from 'antd';

import { usePostRequest } from '../../hooks/usePostRequest'

const { Option } = Select;

const Sticker = ({stickersData, fetchMembersData, isLoading, id}) => {
    const { callPost, loading } = usePostRequest(()=>{
        fetchMembersData();
    });
    const today = dayjs();
    const [stickerInfoData, setStickerInfoData] = useState([])

    const handleDelete = (key) => {
        const newData = [...stickerInfoData];
        newData.splice(key, 1); 
        setStickerInfoData(() => newData)
    };
      
    const addRow = () => {
        const newData = [...stickerInfoData];
        newData.push({
            car_types: '',
            models: '',
            plate_nos: '',
            car_stickers: '',
            date_issueds: undefined,
            exp_dates: undefined,
            stats: '',
            isWritable: true,
        });
        setStickerInfoData(newData);
    };

    const handleTable = (e, index, name, isDate) => {
        if(isDate){
            setStickerInfoData(prevState => {
                const newState = [...prevState];
                newState[index] = { 
                    ...newState[index],
                    [name]: e
                };
                return newState;
            });
        } else {
            const { value } = e.target

            setStickerInfoData(prevState => {
            const newState = [...prevState];
            newState[index] = { 
                ...newState[index],
                [name]: value
            };
            return newState;
            });
        }
    }
    const handleRowClick = (row_id) => {
        const newData = stickerInfoData?.map((item, index) => ({
          ...item,
          isWritable: row_id === index ? !item.isWritable : item.isWritable,
        }));
        setStickerInfoData(newData);
    };

    const defaultColumns = [
        {
            title: 'Car Type',
            dataIndex: 'car_types',
            align: 'center',
            key: 'car_types',
            render: (_, record, index) => (
                record.isWritable ? (
                    
                    <Input
                        value={record.car_types}
                        onChange={(e) => handleTable(e, index, "car_types")}
                    />
                ) : record.car_types
            ),
        },
        {
            title: 'Model',
            dataIndex: 'models',
            align: 'center',
            key: 'models',
            render: (_, record, index) => (
                record.isWritable ? (
                
                    <Input
                        value={record.models}
                        onChange={(e) => handleTable(e, index, "models")}
                    />
                ) : record.models
            ),
        },
        {
            title: 'Plate No.',
            dataIndex: 'plate_nos',
            align: 'center',
            key: 'plate_nos',
            render: (_, record, index) => (
                record.isWritable ? (
                
                    <Input
                        value={record.plate_nos}
                        onChange={(e) => handleTable(e, index, "plate_nos")}
                    />
                ) : record.plate_nos
            ),
        },
        {
            title: 'Car Sticker',
            dataIndex: 'car_stickers',
            align: 'center',
            key: 'car_stickers',
            render: (_, record, index) => (
                record.isWritable ? (
                
                    <Input
                        value={record.car_stickers}
                        onChange={(e) => handleTable(e, index, "car_stickers")}
                    />
                ) : record.car_stickers
            ),
        },
        {
            title: 'Date Issued',
            dataIndex: 'date_issueds',
            align: 'center',
            key: 'date_issueds',
            render: (_, record, index) => (
                record.isWritable ? (
                    <DatePicker        
                        style={{width:'100%'}}
                        value={record.date_issueds}
                        onChange={(e) => handleTable(e, index, "date_issueds", true)}
                    />
                ) : record.date_issueds?.format('MMMM D, YYYY')
            ),
        },
        {
            title: 'Exp Date',
            dataIndex: 'exp_dates',
            align: 'center',
            key: 'exp_dates',
            render: (_, record, index) => (
                record.isWritable ? (
                    <DatePicker        
                        style={{width:'100%'}}
                        value={record.exp_dates}
                        onChange={(e) => handleTable(e, index, "exp_dates", true)}
                    />
                ) : record.exp_dates?.format('MMMM D, YYYY')
            ),
        },
        {
          title: 'Stat',
          dataIndex: 'stats',
          align: 'center',
          key: 'stats',
          render: (_, record, index) => (
            record.isWritable ? (
                <Select 
                    style={{width:'100%'}}
                    value={record.stats}
                    placeholder="Select a Stats" 
                    onChange={(e) => handleTable(e, index, "stats", true)}
                >
                    <Option value="Active">Active</Option>
                    <Option value="Expired">Expired</Option>
                </Select>
            ) : record.stats
          ),
        },
        {
            title: '',
            dataIndex: '',
            align: 'center',
            render: (_, record, index) => (
                <Space>
                    {
                        (record.id) && (
                            <div 
                                onClick={() => handleRowClick(index)}
                                className='cursor'
                            >
                                <Edit/>
                            </div>
                        )
                    }
                    <div 
                        onClick={() => handleDelete(index)}
                        className='cursor'
                    >
                        <Delete  
                            style={{
                                color: 'red',
                            }}
                        />
                    </div>
                </Space>
            ),
            onCell: () => ({
                onClick: (e) => {
                    e.stopPropagation();
                },
            }),
        },
    ];
    const handleCreateSticker = () => {
        try {
          const newValues = {
            member_id: id,
            id: [],
            car_types: [],
            models: [],
            plate_nos: [],
            car_stickers: [],
            date_issueds: [],
            exp_dates: [],
            stats: [],
          };
      
          stickerInfoData?.forEach(item => {
            newValues.id.push(item.id || "");
            newValues.car_types.push(item.car_types || "");
            newValues.models.push(item.models || "");
            newValues.plate_nos.push(item.plate_nos || "");
            newValues.car_stickers.push(item.car_stickers || "");
            newValues.date_issueds.push(item.date_issueds ? item.date_issueds.format("YYYY-MM-DD") : "");
            newValues.exp_dates.push(item.exp_dates ? item.exp_dates.format("YYYY-MM-DD") : "");
            newValues.stats.push(item.stats || "");
          });
      
          callPost(
            "members/update_sticker", 
            newValues,
            false,
          );
        } catch (error) {
          toast.error('Validation Failed', error);
        }
    };
    const validateArray = (array) => {
        if(array.length === 0){
            return false
        } else {
            return array.every((item) => {
                return item.car_types !== "" || item.models !== "" || item.plate_nos !== "" || item.car_stickers !== "" || item.stats !== "" || item.date_issueds !== undefined ||  item.exp_dates !== undefined;
            });
        }
    };  

    useEffect(() => {
        if(stickersData){
            const lockers_data = stickersData?.map((data) => ({
                id: data.id,
                car_types: data.car_type,
                models: data.model,
                plate_nos: data.plate_no,
                car_stickers: data.car_sticker,
                date_issueds: data.date_issued ?  dayjs(data.date_issued) : undefined,
                exp_dates: data.exp_date ?  dayjs(data.exp_date) : undefined, 
                stats: today.isAfter(dayjs(data.exp_date)) ? 'Expired' : data.stat,
                added_by: data.added_by,
                added_on: data.added_on,
                updated_by: data.updated_by,
                updated_on: data.updated_on,
                is_deleted: data.is_deleted,
            }))
             
            setStickerInfoData(lockers_data)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stickersData])
 
    return (
        <Row className='tab-container custom-padding'>
            <Col span={24}>
                <Form 
                    layout="vertical"
                >
                    <Row>
                        <Col span={24} className='responsive-overflow-y'>
                            <Table
                                bordered
                                dataSource={stickerInfoData}
                                columns={defaultColumns}
                                pagination={false}
                                loading={isLoading}
                                scroll={{ x: 2000 }} 
                            />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} className='responsive-inline responsive-width mt-4' >
                        <Col span={24}>
                            <Button 
                                type="primary" 
                                onClick={addRow}
                            >
                                Add Row
                            </Button>
                        </Col>
                    </Row>
                    <Row className='btn-footer'>
                        <Space className='p-2'>
                            <Button
                                onClick={handleCreateSticker}
                                loading={loading}
                                type='primary'
                                disabled={!validateArray(stickerInfoData)}
                                className='button-color btn-header'
                            >
                                Save
                            </Button>
                        </Space>
                    </Row>
                </Form>
            </Col>
        </Row>
    )
}
export default Sticker
